import { findUserWithEmailApi, getEmailSuggestionsApi, getRequestedListApi, raiseNotificationApi, setStatusOfUserRelApi } from 'Constants';
import { Context } from 'Context/Context';
import ProfesssionalDetailsPopUp from 'Modals/ProfesssionalDetailsPopUp';
import React, { useContext, useEffect, useState } from 'react'

function Staffs({setSentReq}) {
    const [associate, setAssociate] = useState("");
    const [foundAssociate, setFoundAssociate] = useState(null);
    const {userDetails, makeApiCallFunc} = useContext(Context);
    const email = userDetails?.email;
    const regex = /@([\w.-]+)$/;
    const match = email.match(regex)[0];
    const [showModal, setShowModal] = useState(false);
    const [singleUser, setSingleUser] = useState(null);
    const profData = {
        "First name" : "firstName",
        "Last name" : "lastName",
        "Email" : "email",
        "Designation" : "legalType",
        "Firm Name" : "company",
        "Phone number" : "phoneNumber",
        "Experience" : "experience",
        "Law Firm URL" : "lawFirmLink",
        "LinkedIn" : "linkedin"  
    }
    const [suggestions, setSuggestions] = useState([]);

    const findAttorney = () => {
        makeApiCallFunc(findUserWithEmailApi,
            {
                findingAssistant: true,
                email: associate + match
            },
            ({data}) =>{ 
                setFoundAssociate(data); 
                console.log(data)
            },
            (data) => console.log(data),

        )
    }
    const addStaff = () => {
        makeApiCallFunc(setStatusOfUserRelApi,
            {
                assistantId: foundAssociate?._id,
                userId: userDetails?._id,
                status: 1
            },
            (data) => {
                setSentReq(prev => !prev);
                setAssociate('');
                setFoundAssociate(null);
                const notificationObj = {
                    title : "Access for " + userDetails?.firstName + " " + userDetails?.lastName + " case profile has been granted",
                    is_read : false,
                    sender: userDetails._id,
                    type: "1",
                    receiver:  foundAssociate?._id,
                    content: "You have been provided access to act on behalf of "+userDetails?.firstName+" "+userDetails?.lastName+". You shall now have access to their dashboard.",
                    }
                makeApiCallFunc(raiseNotificationApi, 
                    notificationObj, 
                        (data) => console.log(data),
                        (error) => console.log(error)
                    )
            },
            (data) => console.log(data),

        )
    }
   
    // useEffect(()=>{
    //     if(associate.length > 3)
    //     {
    //         makeApiCallFunc(getEmailSuggestionsApi, 
    //             {
    //                 term: associate,
    //                 emailDomain: match,
    //                 isAssistant: false
    //             },
    //             ({data}) => {
    //                 setSuggestions(data);
    //             },
    //             (data) => console.log(data),
    //         )
    //     }
        
    // },[associate])
  return (
        <div  className='w-full'>
        {
        showModal &&
        <>
        <ProfesssionalDetailsPopUp uploadNew={showModal} onClose={() => setShowModal(false)} singleUser={singleUser} profData= {profData}/>
        </>
        }
        <div className='w-full flex lg:flex-row flex-col items-center justify-between'>
            <div className="relative mt-2 mr-4 shadow-sm flex items-center w-full">
                <input
                type="text"
                name="email"
                id="email"
                className="italic w-full focus-visible:ring-0 mr-2 bg-gray-50 border-0 py-1 pl-3 text-gray-900 placeholder:text-gray-400"
                placeholder="Enter Email of the Assistant"
                onChange={(e)=>{
                    const value = e.target.value;
                    const sanitizedValue = value.replace(/[@]/g, '');
                    setAssociate( sanitizedValue)
                }}
                value = {associate} 
                />
                <div>{match}</div>
                
            </div>
             <div className={(associate.length > 0 ? 'bg-green-600' : 'bg-gray-600') + ' text-white rounded p-2 cursor-pointer justify-center flex px-4 mt-4 text-sm w-[200px]'} onClick={findAttorney}>Find Assistant</div>

        </div>
        {/* <div>
            {
                suggestions?.map((item, key) => {
                    return (<div className='p-2 border-b-1'>{item?.email}</div>)
                })
            }
        </div> */}
        {
            foundAssociate ?
            foundAssociate.firstName ? 
            <div className='w-full flex justify-between lg:px-4 py-2 items-center bg-gray-50 lg:border mt-10 '>
               <div className='w-12 h-12'> <img src = {foundAssociate.profilePic}/> </div>
               <div className='w-10 h-10 flex items-center'> {foundAssociate.firstName} </div>
               <div className='w-10 h-10 flex items-center'> {foundAssociate.lastName} </div>
               <div className='w-10 h-10 underline text-sm text-sky-600 cursor-pointer flex items-center' 
               onClick={() => {setSingleUser(foundAssociate); setShowModal(true)}}
               > Details </div>
               <div className='text-white flex items-center rounded p-2 px-4 text-xs w-max cursor-pointer h-10 bg-green-600 ' onClick={addStaff}>Add to team</div>
            </div>
            :
            <div className='w-full  flex justify-center flex-col py-4 bg-red-50 text-sm px-4 py-2 items-center  border mt-10 '>Assistant not found on the website. 
            <span className='text-gray-600'>Are you sure the user is registered with the same email Id you entered ?</span>
            </div>
            :
            ''
        }
    </div>
    )
}


export default Staffs;